webpackJsonp([35783957827783],{

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  min-height: 100vh;\n  background-image: url(', ');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n'], ['\n  min-height: 100vh;\n  background-image: url(', ');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 48em;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 4rem 2rem;\n'], ['\n  max-width: 48em;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 4rem 2rem;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n  mix-blend-mode: screen;\n'], ['\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n  mix-blend-mode: screen;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  color: white;\n\n  @media (min-width: 40em) {\n    font-size: 1.125rem;\n  }\n'], ['\n  color: white;\n\n  @media (min-width: 40em) {\n    font-size: 1.125rem;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _hero = __webpack_require__(103);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var HeroWrapper = _styledComponents2.default.div(_templateObject, _hero2.default);
	
	var HeroContainer = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.div(_templateObject3);
	
	var HeroText = _styledComponents2.default.div(_templateObject4);
	
	var Hero = function Hero(_ref) {
	  var pages = _ref.pages,
	      language = _ref.language;
	
	  return _react2.default.createElement(
	    HeroWrapper,
	    null,
	    pages.filter(function (page) {
	      return page.node.node_locale === language;
	    }).map(function (_ref2) {
	      var page = _ref2.node;
	
	      return _react2.default.createElement(
	        HeroContainer,
	        { key: page.id },
	        _react2.default.createElement(
	          Title,
	          null,
	          _react2.default.createElement(_gatsbyImage2.default, {
	            sizes: page.image.sizes,
	            alt: 'Itsen\xE4isen Suomen poliisi',
	            title: 'Itsen\xE4isen Suomen poliisi' })
	        ),
	        _react2.default.createElement(HeroText, { dangerouslySetInnerHTML: { __html: page.body.childMarkdownRemark.html } })
	      );
	    })
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: block;\n  padding: 1.5rem 1rem;\n  color: inherit;\n  text-decoration: none;\n  text-align: center;\n  transition: all .1s ease;\n  box-shadow: inset 0 -1px 0 rgba(0,0,0,.125);\n\n  h2 {\n    margin: 0;\n  }\n\n  h4 {\n    margin: 0;\n    font-weight: 400;\n  }\n\n  :hover {\n    background-color: #ececec;\n  }\n'], ['\n  display: block;\n  padding: 1.5rem 1rem;\n  color: inherit;\n  text-decoration: none;\n  text-align: center;\n  transition: all .1s ease;\n  box-shadow: inset 0 -1px 0 rgba(0,0,0,.125);\n\n  h2 {\n    margin: 0;\n  }\n\n  h4 {\n    margin: 0;\n    font-weight: 400;\n  }\n\n  :hover {\n    background-color: #ececec;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PostLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject);
	
	var Timeline = function Timeline(_ref) {
	  var pages = _ref.pages,
	      language = _ref.language;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    pages.filter(function (page) {
	      return page.node.featuredContent === null && page.node.node_locale === language;
	    }).map(function (_ref2) {
	      var page = _ref2.node;
	
	      return _react2.default.createElement(
	        PostLink,
	        { to: page.slug, key: page.id },
	        _react2.default.createElement(
	          'h2',
	          null,
	          page.title
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          page.subtitle
	        )
	      );
	    })
	  );
	};
	
	exports.default = Timeline;
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _hero = __webpack_require__(53);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _timeline = __webpack_require__(54);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _i18n = __webpack_require__(37);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var pages = this.props.data.pages.edges;
	    var homePages = this.props.data.homePages.edges;
	    var currentLanguage = 'fi';
	
	    if (_i18n2.default.language != currentLanguage) _i18n2.default.changeLanguage(currentLanguage);
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_hero2.default, { pages: homePages, language: currentLanguage }),
	      _react2.default.createElement(_timeline2.default, { pages: pages, language: currentLanguage })
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	IndexPage.propTypes = propTypes;
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-76ad4554123f9915d241.js